// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"f80c0b88","169":"d8d96093"}[chunkId] + ".chunk.css";
};